import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import * as React from 'react';
import InputBase from './InputBase';
import { ConfigContext, SizeContext, LocaleContext } from '../ConfigProvider';
var useContext = React.useContext;
/**
 * @desc 输入框
 * @link https://bedrock.netease.com/components/input
 */

var InnerInput = function InnerInput(props, ref) {
  var _useContext = useContext(ConfigContext),
      getPrettyCls = _useContext.getPrettyCls,
      getLocale = _useContext.getLocale;

  var contextSize = useContext(SizeContext);
  var contextLocale = useContext(LocaleContext);
  var localeMessages = getLocale(contextLocale, 'Input');
  return /*#__PURE__*/React.createElement(InputBase, _objectSpread(_objectSpread({
    ref: ref,
    size: contextSize,
    placeholder: localeMessages.placeholder,
    locale: localeMessages
  }, props), {}, {
    getPrettyCls: getPrettyCls
  }));
};

var Input = /*#__PURE__*/React.forwardRef(InnerInput);
export default Input;